module.exports = __webpack_public_path__ + "static/media/Condumex.eabaf32e.jpg";